import { Link } from "react-router-dom";

function fmtDate(d) {
  if (!d) return "";
  const date = new Date(d);
  return isNaN(date) ? "" : date.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
}

function toArticlesArray(data) {
  // New shape: data = [{ title, slug, content, raw? }]
  if (Array.isArray(data) && data.length && (data[0]?.title || data[0]?.name)) {
    return data.map(a => ({
      title: a.title || a.name,
      slug: a.slug || a.link,
      date: a.raw?.updatedAt || a.updatedAt || a.createdAt || a.raw?.createdAt || "",
    })).filter(a => a.title && a.slug);
  }

  // Legacy fallback: data = { categories:[{name:'Nyheter', items:[...]}] }
  const nyheter = data?.find?.(c => c.name === "Nyheter")?.items || [];
  return nyheter.map(n => ({
    title: n.name || n.title,
    slug: n.link || n.slug,
    date: n.date || "",
  })).filter(a => a.title && a.slug);
}

export default function News({ data }) {
  const articles = toArticlesArray(data)
    .sort((a, b) => (new Date(b.date) - new Date(a.date)) || a.title.localeCompare(b.title));

  return (
    <section className="p-8 lg:py-16 lg:px-48">
      <h2 className="text-3xl font-bold mb-4">Egna Nyheter</h2>

      <div className="nyheter-container">
        {articles.map(a => (
          <div key={a.slug} className="nyhet border-t border-gray-300 my-4 py-2">
            {a.date && (
              <p className="text-gray-600 text-sm italic mb-2">
                {fmtDate(a.date)}
              </p>
            )}
            <h3 className="font-bold">{a.title}</h3>
            <Link to={`/nyheter/${a.slug}`} className="text-sm text-gray-600 hover:underline">
              Läs mer…
            </Link>
          </div>
        ))}

        {!articles.length && (
          <p className="text-gray-500 italic">Inga nyheter ännu.</p>
        )}
      </div>
    </section>
  );
}

